var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("app-modal", {
        attrs: { "max-width": "1200", persistent: "" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.title))]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showLoading,
                        expression: "showLoading",
                      },
                    ],
                    staticClass: "text-xs-center",
                  },
                  [
                    _c("v-progress-circular", {
                      attrs: { size: 70, color: "primary", indeterminate: "" },
                    }),
                    _vm._v(" "),
                    _c("h2", [_vm._v("Loading...")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-form",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showLoading,
                        expression: "!showLoading",
                      },
                    ],
                    ref: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c("v-subheader", { staticClass: "headline" }, [
                      _vm._v("General"),
                    ]),
                    _vm._v(" "),
                    _c("ImporterGeneral", {
                      attrs: {
                        Title: _vm.title,
                        data: _vm.generalData,
                        ImporterType: _vm.ImporterType,
                      },
                      on: { setGeneralData: _vm.setGeneralData },
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("v-divider"),
                    _vm._v(" "),
                    _c("v-subheader", { staticClass: "headline" }, [
                      _vm._v("Shared"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", "pr-1": "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: "Station Name",
                                rules: _vm.nullRule,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "append",
                                  fn: function () {
                                    return [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c("v-icon", _vm._g({}, on), [
                                                    _vm._v("info_outline"),
                                                  ]),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Importer would filter the files which contain the station name value in the file name for processing.\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                              model: {
                                value: _vm.StationName,
                                callback: function ($$v) {
                                  _vm.StationName = $$v
                                },
                                expression: "StationName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("v-divider"),
                    _vm._v(" "),
                    _c("v-subheader", { staticClass: "headline" }, [
                      _vm._v("Mappings"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-tabs",
                      {
                        attrs: { dark: "", grow: "" },
                        model: {
                          value: _vm.model,
                          callback: function ($$v) {
                            _vm.model = $$v
                          },
                          expression: "model",
                        },
                      },
                      [
                        _c("v-tabs-slider"),
                        _vm._v(" "),
                        _c(
                          "v-tab",
                          { attrs: { href: "#tab-1" } },
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v("storage"),
                            ]),
                            _vm._v(
                              _vm._s(_vm.AQUARIUS_SERVER_NG) + "\n          "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tabs-items",
                      {
                        model: {
                          value: _vm.model,
                          callback: function ($$v) {
                            _vm.model = $$v
                          },
                          expression: "model",
                        },
                      },
                      [
                        _c(
                          "v-tab-item",
                          { attrs: { value: "tab-1" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "success",
                                on: {
                                  click: function ($event) {
                                    return _vm.addLength(
                                      _vm.NGConfig,
                                      _vm.IMPORTER_TYPE_GOES
                                    )
                                  },
                                },
                              },
                              [
                                _c("v-icon", [_vm._v("add")]),
                                _vm._v(
                                  _vm._s(_vm.$t("Button.Add")) +
                                    "\n            "
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.NGConfig, function (item, i) {
                              return _c(
                                "v-layout",
                                { key: i },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", "pr-3": "" } },
                                    [
                                      _c("ImporterTimeSeriesSelector", {
                                        attrs: {
                                          serverType: _vm.AQUARIUS_SERVER_NG,
                                          config: _vm.NGConfig,
                                        },
                                        model: {
                                          value: _vm.NGConfig[i].TimeSeries,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.NGConfig[i],
                                              "TimeSeries",
                                              $$v
                                            )
                                          },
                                          expression: "NGConfig[i].TimeSeries",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", "pl-3": "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.parameterNameInFile,
                                          rules: _vm.linkRuleNG,
                                        },
                                        model: {
                                          value: _vm.NGConfig[i].ParameterName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.NGConfig[i],
                                              "ParameterName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "NGConfig[i].ParameterName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "icon_border",
                                      staticStyle: { "margin-top": "15px" },
                                      attrs: { small: "", icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.subtractLength(
                                            i,
                                            _vm.NGConfig
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "delete" } },
                                        [_vm._v("clear")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("ImporterAlert", { attrs: { AlertNG: _vm.AlertNG } }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "success",
                      disabled: !_vm.canSave,
                      loading: _vm.btnLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        return _vm.close()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.showModal,
          callback: function ($$v) {
            _vm.showModal = $$v
          },
          expression: "showModal",
        },
      }),
      _vm._v(" "),
      _c(
        "app-confirmation-modal",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.saveFailed,
            callback: function ($$v) {
              _vm.saveFailed = $$v
            },
            expression: "saveFailed",
          },
        },
        [
          _c("template", { slot: "app-modal-title" }, [
            _vm._v("\n      Failed\n    "),
          ]),
          _vm._v(" "),
          _c("template", { slot: "app-modal-text" }, [
            _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "app-modal-actions" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary", outline: "" },
                  on: {
                    click: function ($event) {
                      _vm.saveFailed = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticStyle: { "text-align": "center" },
          attrs: { color: _vm.snackColor, timeout: null, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Close")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }